export default __webpack_public_path__ + "static/media/5.fa765e4f.svg";